import React from 'react'

export default function SocialMediaEmbed ({component}) {
const {smEmbed} = component;  
    return (
        <div style={{maxWidth: '100%'}} dangerouslySetInnerHTML={{__html: smEmbed}}/>
    )
}